// extracted by mini-css-extract-plugin
module.exports = {"h1f6vzg":"h1f6vzg"};